export default "__VITE_ASSET__YFXHMO$k__"